<template lang="html">

    <form id="formContacto" class="fo" @submit.prevent="validateBeforeSubmit">
      <div class="contenedor-input">
        <input type="text" class="input-text" v-validate="'required'"
          name="nombre" placeholder="Nombre y apellidos*" v-model="data.nombre" />
        <span :class="['error',{'animated shake' : clicked}]" v-if="clicked">{{
          errors.first('nombre') }}</span>
      </div>
  
      <div class="contenedor-input">
        <input type="text" class="input-text" v-validate="'required|email'"
          name="email" placeholder="Email*" v-model="data.email" />
        <span :class="['error',{'animated shake' : clicked}]" v-if="clicked">{{
          errors.first('email') }}</span>
      </div>
  
      <template v-if="isEmpresa | !isLogged">
  
      <div class="contenedor-input" >
        <input type="text" class="input-text" v-validate="'required'"
          name="empresa" placeholder="Empresa*" v-model="data.empresa" />
        <span :class="['error',{'animated shake' : clicked}]" v-if="clicked">{{
          errors.first('empresa') }}</span>
      </div>
  
      <p>Por favor, indique si su consulta está relacionada con:</p>
  
      <div class="contenedor-checks row-start">
  
        <div class="contenedor-check -radio" :error="errors.has('tipopregunta')">
          <input type="radio" id="practicas" v-validate="'required'"
            name="tipopregunta" v-model="tipopregunta" value="practicas">
          <label for="practicas">Prácticas</label>
          <span :class="['error',{'animated shake' : clicked}]" v-if="clicked">{{
            errors.first('tipopregunta') }}</span>
        </div>
  
        <div class="contenedor-check -radio" :error="errors.has('tipopregunta')">
          <input type="radio" id="empleo" v-validate="'required'"
            name="tipopregunta" v-model="tipopregunta" value="empleo">
          <label for="empleo">Empleo</label>
          <span :class="['error',{'animated shake' : clicked}]" v-if="clicked">{{
            errors.first('tipopregunta') }}</span>
        </div>
  
      </div>
  
    </template>
  
      <div class="contenedor-input">
        <input type="text" class="input-text" name="asunto" placeholder="Asunto*"
          v-model="data.titulo" v-validate="'required'"/>
          <span :class="['error',{'animated shake' : clicked}]" v-if="clicked">{{
            errors.first('asunto') }}</span>
      </div>
  
  
      <div class="contenedor-input">
        <textarea placeholder="Mensaje*" name="mensaje" v-validate="'required'"
          v-model="data.mensaje"></textarea>
        <span :class="['error',{'animated shake' : clicked}]" v-if="clicked">{{
          errors.first('mensaje') }}</span>
      </div>
  
      <template v-if="isCandidato">
  
      <a class="show-data-protection" v-if="!showcheck" @click="showpopup= true" :error="notshow">Pulsa
        aquí para
        consultar y aceptar la protección de datos</a>
  
      <div class="contenedor-check" v-if="showcheck"
        :error="errors.has('comunicaciones')">
        <input type="checkbox" id="comunicaciones" name="comunicaciones"
          v-validate="'required'" v-model="comunicaciones">
        <label for="comunicaciones">Acepto y autorizo a que mis datos sean
          tratados por la Universidad Francisco de
          Vitoria, con las finalidades indicadas anteriormente y para remitirme,
          por cualquier medio, incluidos los
          electrónicos (SMS, Whatsapp, correo electrónico y redes sociales),
          información sobre cualquier curso o programa
          actual o futuro de la Universidad Francisco de Vitoria, jornadas de
          puertas abiertas, talleres de orientación y
          sesiones informativas, así como recordatorios de las mismas.</label>
        <span :class="['error',{'animated shake' : clicked}]" v-if="clicked">{{
          errors.first('comunicaciones') }}</span>
      </div>
  
  
      <div class="contenedor-check" :error="errors.has('tratamientodedatos')">
        <input type="checkbox" id="tratamientodedatos" v-validate="'required'"
          name="tratamientodedatos" v-model="tratamientodedatos">
        <label for="tratamientodedatos">Acepto y autorizo a que mis datos sean
          tratados por la Universidad Francisco de
          Vitoria, para su análisis y segmentación en relación con las
          preferencias educativas. Puede consultar la
          información ampliada en la web: <a
            href="www.ufv.es/politica-de-privacidad-doiu/"
            target="_blank">www.ufv.es/politica-de-privacidad-doiu/</a></label>
        <span :class="['error',{'animated shake' : clicked}]" v-if="clicked">{{
          errors.first('tratamientodedatos') }}</span>
        </div>
  
      </template>
  
  
  
      <div class="contenedor-check" v-if="!isCandidato"
        :error="errors.has('politica')">
        <input type="checkbox" id="politica" name="politica"
          v-validate="'required'" v-model="politica">
        <label for="politica">He leído y acepto la <a href="https://www.ufv.es/politica-de-privacidad/" target="_blank">Política de privacidad*</a></label>
        <span :class="['error',{'animated shake' : clicked}]" v-if="clicked">{{
          errors.first('politica') }}</span>
      </div>
  
      <p class="error -big" v-if="errors.items.length != 0 & clicked">Por favor, revise el formulario, los campos marcados en rojo son obligatorios o contienen algún error.</p>
  
      <button class="btn" :loading="loading">Enviar</button>
  
      <div class="cover-popup row-center" v-if="showpopup">
        <span class="close-cover" @click="showpopup= false"></span>
        <div class="popup">
          <button class="close" @click="showpopup= false">✕</button>
  
          <h2 class="title-pop">Información relativa a protección de datos</h2>
          <p>Información relativa a la protección de sus datos de carácter
            personal: el responsable del tratamiento de sus
            datos es la Universidad Francisco de Vitoria (UFV).</p>
          <p>La finalidad del tratamiento es atender su solicitud de información
            sobre programas de grado y postgrado
            organizados por la UFV, invitarle a jornadas de puertas abiertas,
            sesiones informativas y talleres que puedan
            ayudarle a tomar una decisión sobre los estudios que va a cursar y
            mantenerle puntualmente informado sobre
            actuales y futuros programas que puedan ser de su interés por medios
            electrónicos, así como para su análisis y
            segmentación en relación con sus preferencias educativas. La
            legitimación del tratamiento es el consentimiento
            del interesado marcando las casillas destinadas a tal efecto. La
            información facilitada no será comunicada a
            terceros, salvo a prestadores de servicio con acceso a datos. Los
            datos serán conservados hasta 3 años desde
            su recogida.</p>
          <p>En el caso de matricularse en algún programa académico, sus datos de
            carácter personal serán tratados
            conforme a lo especificado en la información de protección de datos de
            la matrícula.</p>
          <p>Puede ejercitar sus derechos de acceso, rectificación, supresión,
            oposición, limitación del tratamiento y
            portabilidad mediante un escrito dirigido a la Secretaría General de
            la Universidad Francisco de Vitoria,
            Ctra. M-515 Pozuelo-Majadahonda Km. 1,800; 28223, Pozuelo de Alarcón
            (Madrid), o al correo electrónico
            dpd@ufv.es.</p>
          <p>Si a través del presente formulario facilita datos de terceras
            personas, le informamos de que queda obligado
            a informar al interesado sobre el contenido de esta cláusula.</p>
          <button class="btn" @click="entendido">Entendido</button>
  
        </div>
      </div>
  
    </form>
  
  </template>
  
  <script lang="js">
  
  
    import Vue from 'vue';
    import VeeValidate from 'vee-validate';
  
    Vue.use(VeeValidate);
  
    import { mapGetters, mapActions } from 'vuex'
  
    export default {
      name: 'formulario',
      props: [],
      mounted() {
        if(this.isCandidato){
          setTimeout(e => {
            this.requestBasicosAlumno().then(r => {
              this.setData(r);
            });
          },100)
          this.showcheck = false;
          this.data.type = "candidato";
        }else{
          this.data.type = "empresa";
        }
      },
      data() {
        return {
          clicked: false,
          showpopup: false,
          showcheck : true,
          tratamientodedatos : false,
          politica : false,
          notshow : false,
          comunicaciones : false,
          loading : false,
          tipopregunta : '',
          data : {
              nombre: "",
              email: "",
              mensaje: "",
              titulo: "",
              consultaPracticas : false,
              consultaempleo : false,
              empresa : ''
        }
      }
      },
      methods: {
        ...mapActions(['sendContacto','requestBasicosAlumno']),
        setData(r){
          this.data.nombre = `${r.nombre} ${r.apellido1}`;
          this.data.email = r.email;
        },
        validateBeforeSubmit: function () {
          if(this.showcheck){
            this.clicked = true;
            this.$validator.validateAll().then(canSend => {
              if (canSend) {
                this.loading = true;
  
                if(this.tipopregunta == 'practicas'){
                  this.data.consultaPracticas = true;
                }else if(this.tipopregunta == 'empleo'){
                  this.data.consultaempleo = true;
                }
  
                this.sendContacto(this.data)
                  .then(result => {
                    if(result){
                      this.reset();
                    }
                    this.loading = false;
                  });
              }
            });
          }else{
            this.notshow = true;
          }
        },
        entendido(){
          this.showpopup = false;
          this.showcheck = true;
          this.notshow = false;
          this.$validator.reset();
        },
        reset(){
          this.data = {
            nombre: "",
            email: "",
            mensaje: "",
            titulo: "",
            consultaPracticas : false,
            consultaempleo : false,
            empresa : ''
          }
          this.clicked= false;
          this.showpopup= false;
          // this.showcheck = false;
          this.tratamientodedatos = false;
          this.notshow = false;
          this.comunicaciones = false;
          this.tipopregunta = '';
          this.$validator.reset();
        }
      },
      computed: {
        ...mapGetters({
          isLogged : 'getLogged',
          isCandidato : 'isCandidato',
          isEmpresa : 'isEmpresa'
        })
      }
    }
  </script>
  
  <style scoped lang="scss">
    .contenedor-checks{
      margin-top: 20px;
  
      .contenedor-check{
        margin-right: 10px;
      }
    }
  </style>


// WEBPACK FOOTER //
// src/components/views/contacto/formulario.vue